import styled from 'styled-components'

import Text, { TextSize } from 'src/components/Typography/Text'

export const StyledHeader = styled(Text).attrs(() => ({ strong: true, size: TextSize.Large }))`
  display: block;
  padding: 6px 6px 4px 0;
  color: ${({ theme }) => theme.colorTextDescription};
  border-bottom: 1px solid ${({ theme }) => theme.colorFillSecondary};
`
export const StyledSubHeader = styled(Text).attrs(() => ({ strong: true }))`
  display: block;
  padding: 6px;
  color: ${({ theme }) => theme.colorTextSecondary};
`

export const SectionCount = styled(Text)`
  color: ${({ theme }) => theme.colorTextQuaternary};
`

export const EmptySearchHint = styled(Text)`
  display: block;
  padding: 8px 8px 8px 16px;
  font-style: italic;
  color: ${({ theme }) => theme.colorTextTertiary};
`
